import React from 'react';

import ClientBookingOptionRow from '../../widget/clientBookingOptionRow';
import ButtonComponent from '../../../../common/genericComponents/redesign/buttonComponent/buttonComponent';
import MLargeViewMeetingStatusComponent from '../../../mentorSchedulingComponentsNew/mCalendarRightContainer/components/mCalendarRequestsItemComponent/components/mLargeViewMeetingComponents/mLargeViewMeetingStatusComponent/mLargeViewMeetingStatusComponent';
import SuccessIcon from '../../../../../assets/svgComponents/SuccessIcon';
import TimeZonePicker from '../../../datePicker/timeZonePicker';

import './anSchedulingInWidgetStep3.css';

const AnSchedulingInWidgetStep3 = ({
  extendedMentorDto = {},
  isAutoApprovalOn = false,
  bookingOptions = [],
  selectedTimezone = '',
  timeFormat = '',
  onReschedule = () => {},
}) => {
  const coverEntireWidth =
    bookingOptions.findIndex(
      (bookingOption) =>
        bookingOption.rangeEndTimeSender < new Date().getTime(),
    ) !== -1;
  const getNonAutoApprovedUI = () => {
    return (
      <>
        <div className="et-n-non-auto-approval-ui-wrap">
          <MLargeViewMeetingStatusComponent
            hideTooltip={true}
            meetingStatus={'ANONYMOUS'}
            statusText={'MEETING PENDING APPROVAL - THEIR TURN'}
          />
          <div className="et-n-non-auto-approval-title-txt">
            Your request was sent.
          </div>
          <div className="et-n-non-auto-approval-subtitle-txt">
            Waiting for approval. Please wait for email confirmation.
          </div>
          <div className="et-n-non-auto-approval-options-txt">
            Meeting options:
          </div>
          <div
            className={`et-n-non-auto-approval-booking-options-tz-wrap ${
              coverEntireWidth
                ? 'et-n-non-auto-approval-booking-options-tz-wrap-passed-wrap'
                : ''
            }`}>
            {bookingOptions.map((bookingOption, index) => {
              return (
                <React.Fragment key={index}>
                  <ClientBookingOptionRow
                    isAnonymousPage={true}
                    showAcceptBtn={false}
                    showDelete={false}
                    showEditDeleteBtn={false}
                    showPrevNextBtn={false}
                    bookingOption={bookingOption}
                    selectedTimezone={selectedTimezone}
                    timeFormat={timeFormat}
                    handleDateClick={() => {}}
                    handleDelete={() => {}}
                    handleTimeClick={() => {}}
                    onDateChanged={() => {}}
                    setBookingRowIndForEditDelete={() => {}}
                  />
                  {bookingOptions.length > 1 &&
                    bookingOptions.length - 1 !== index && (
                      <div className="et-an-or-text">
                        <div className="et-an-or-text-bar" />
                        {'OR'}
                        <div className="et-an-or-text-bar" />
                      </div>
                    )}
                </React.Fragment>
              );
            })}
            {selectedTimezone && (
              <TimeZonePicker
                isDisabled={true}
                selectedTimezone={selectedTimezone}
                globeColor="var(--et-mentor-cta-btn-primary-background-color-fc)"
              />
            )}
          </div>
        </div>
        <div className="et-n-scheduling-final-container-btn">
          <ButtonComponent
            type="primary-outlined"
            isDisabled={false}
            onClick={onReschedule}
            text={'Schedule another appointment'}
          />
        </div>
      </>
    );
  };

  const getAutoApprovedUI = () => {
    return (
      <div className="et-n-auto-approval-ui-wrap">
        <div className="et-n-auto-approval-ui-center-wrap">
          <SuccessIcon fillColor="var(--et-mentor-cta-btn-primary-background-color-fc)" />
          <div className="et-n-auto-approval-title-txt">
            {`Your meeting request with ${extendedMentorDto.mentorDto.displayName} is Confirmed`}
          </div>
          <ClientBookingOptionRow
            isAnonymousPage={true}
            showDelete={false}
            showEditDeleteBtn={false}
            showPrevNextBtn={false}
            bookingOption={Object.values(bookingOptions)[0]}
            selectedTimezone={selectedTimezone}
            timeFormat={timeFormat}
            handleDateClick={() => {}}
            handleDelete={() => {}}
            handleTimeClick={() => {}}
            onDateChanged={() => {}}
            setBookingRowIndForEditDelete={() => {}}
          />
          {selectedTimezone && (
            <TimeZonePicker
              isDisabled={true}
              selectedTimezone={selectedTimezone}
              globeColor="var(--et-mentor-cta-btn-primary-background-color-fc)"
            />
          )}
        </div>
        <div className="et-n-scheduling-final-container-btn">
          <ButtonComponent
            type="primary-outlined"
            isDisabled={false}
            onClick={onReschedule}
            text={'Schedule another appointment'}
          />
        </div>
      </div>
    );
  };

  return (
    <div className="et-n-scheduling-final-container">
      {isAutoApprovalOn ? getAutoApprovedUI() : getNonAutoApprovedUI()}
    </div>
  );
};

export default AnSchedulingInWidgetStep3;
